export const STRATEGY_GROUPS_TABLE_COLUMNS_SIZES = {
  DISPLAY_NAME: 25,
  VERSIONS: 75,
};
